import { UserRepository } from 'src/app/core/repositories/UserRepository';
import { Observable, throwError } from 'rxjs';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { retry, catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  UserDTO,
  UserRequestDTO,  
} from 'src/app/data/dto/UserDTO';
import { User } from 'src/app/auth/_model/User';

@Injectable({
  providedIn: 'root',
})
export class UserRestRepository implements UserRepository {
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }


  public login(request: UserRequestDTO): Observable<UserDTO> {
    const endpoint = environment.login_endpoint;    
    const httpOptions = { headers: this.headers };
    return this.http
      .post<UserDTO>(
        `${environment.url_base}/${endpoint}/`,
        JSON.stringify(request),
        httpOptions
        ).pipe(
            retry(1),
            catchError(this.handleError)
        )
        .pipe(map(result => {
            return result;
        }));
  }

  handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(error);
  }
}
